<template>
   <!-- 账号管理 -->
   <div class="account-management">
        <ab-list-query :class="{addDel: !$isAuth('customer:usercenter:account:add')}">
            <template #right>
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-input
                        size="mini"
                        placeholder="姓名"
                        v-model.trim="formSearch.realName"
                        clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-input
                        size="mini"
                        placeholder="登录名"
                        v-model.trim="formSearch.loginName"
                        clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <el-input
                        size="mini"
                        placeholder="手机号"
                        v-model.trim="formSearch.mobile"
                        clearable
                        >
                        </el-input>
                    </el-col>
                    <el-col :span="4" class="text-left">
                        <el-button @click="search">搜索</el-button>
                        <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                    </el-col>
                </el-row>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="addHandlerEdit" v-if="$isAuth('customer:usercenter:account:add')">新增</el-button>
            </template>

            <template #table>
                <ab-table
                    class="materialTable"
                    ref="table"
                    stripe
                    showEdit
                    showSelection
                    selectionWidth="45"
                    indexWidth="50"
                    widths="200"
                    isFilter="operator"
                    :column-list="columns"
                    :table-list="tableData"
                    :dataListLoading="isloading"
                    :handleSelectionChange="handleSelectionChange"
                    @filterColumns="filterColumns"
                    >
                    <template #operator="scope">
                        <el-tooltip content="暂无该功能权限" placement="bottom" effect="light" :disabled='isAuth?(isAuth && scope.row.permission):(!isAuth && scope.row.permission)'>
                            <span>
                                <el-button type="primary" link @click="EditRow(scope.row)" :disabled="!isAuth && !scope.row.permission">编辑</el-button>
                            </span>
                        </el-tooltip>

                        <i class="dividingLine"></i>
                         
                        <el-tooltip content="暂无该功能权限" placement="bottom" effect="light" :disabled='isAuth?(isAuth && scope.row.permission):(!isAuth && scope.row.permission)'>
                            <span>
                                <el-button type="primary" link class="red" @click="resetRow(scope.row)" :disabled="!isAuth && !scope.row.permission">重置密码</el-button>
                            </span>
                        </el-tooltip>
                    </template>

                    <template #statu="scope">
                        <el-switch v-model="scope.row.status" :active-value="1"  :inactive-value="0" @change="switchState($event, scope.row.id)">
                        </el-switch>
                    </template>
                    <template #username="scope">{{ scope.row.loginAccount.username }}</template>
                    <template #mobile="scope">{{ scope.row.loginAccount.mobile }}</template>
                    <template #email="scope">{{ scope.row.loginAccount.email }}</template>
                    <template #roles="scope">{{ roleNames(scope.row.roleVos)}}</template>
                    <template #attachUrl="scope">
                        <el-button v-if="scope.row.attachUrl" type="primary" @click="viewAttorney(scope.row.attachUrl)" link>查看</el-button>
                    </template>
                </ab-table>
            </template>

            <template #page>
                <ab-page
                    ref="pagination"
                    :pageTotal="page.total"
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :pageSizes="page.pageSizes"
                    @searchForm="searchForm"
                ></ab-page>
            </template>
        </ab-list-query>
        
        <el-drawer v-model="editRow" :direction="direction" custom-class="drawer">
            <template #title>
                <h4>编辑</h4>
                <h4></h4>
            </template>
            <template #default>
                <el-form label-position="top" :model="userinfo" :rules="rules" ref="userinfo">
                    <div class="nameMobile">{{userinfo.realName}}<span>登录名：{{userinfo.username}}</span></div>

                    <el-row :gutter="20">
                        <el-col :span="24">
                        <el-form-item label="手机号" prop="mobile">
                            <el-input size="mini" v-model="userinfo.mobile" clearable></el-input>
                        </el-form-item>
                        </el-col>

                        <el-col :span="24">
                        <el-form-item label="邮箱" prop="email">
                            <el-input size="mini" v-model="userinfo.email" clearable></el-input>
                        </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>

            <template #footer>           
                <el-button type="primary" :loading="btnLoading" @click="confirm">确 定</el-button>
                <el-button @click="editRow = false">取 消</el-button>
            </template>
        </el-drawer>

         <el-drawer v-model="reset" :direction="direction" custom-class="drawer" >
            <template #title>
                <h4>重置密码</h4>
            </template>
            <template #default>
                <el-form label-position="top" :model="reseUserinfo" :rules="resetRules" ref="resetDialog">
                <el-row :gutter="20">
                    <el-col :span="24">
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input size="mini" type="password" v-model="reseUserinfo.newPassword" clearable placeholder="请输入6-18位，包含大小写字母、数字的新密码" show-password></el-input>
                    </el-form-item>
                    </el-col>

                    <el-col :span="24">
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input size="mini" type="password" v-model="reseUserinfo.confirmPassword" clearable placeholder="请再次输入6-18位，包含大小写字母、数字的新密码" show-password></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            </template>

            <template #footer>           
                <el-button type="primary" :loading="resetBtnLoading" @click="resetConfirm">确 定</el-button>
                <el-button  @click="reset = false">取 消</el-button>
            </template>
        </el-drawer>

        <el-drawer v-model="accoutAdd" :direction="direction" custom-class="drawer" >
            <template #title>
                <h4>新增</h4>
            </template>
            <template #default>
                <el-form label-position="top" :model="accoutAddInfo" :rules="accoutAddRules" ref="accoutAddInfo">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="姓名" prop="realName">
                                <el-input v-model="accoutAddInfo.realName" clearable></el-input>
                            </el-form-item>
                        </el-col>

                        <!-- <el-col :span="24">
                            <el-form-item label="登录名" prop="loginName">
                                <el-input v-model="accoutAddInfo.mobile" clearable disabled></el-input>
                            </el-form-item>
                        </el-col> -->

                        <el-col :span="24">
                            <el-form-item label="手机号" prop="mobile">
                                <el-input v-model="accoutAddInfo.mobile" clearable></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="24">
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="accoutAddInfo.email" clearable></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="24">
                            <el-form-item label="身份证号" prop="idCard">
                                <el-input v-model="accoutAddInfo.idCard" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </template>

            <template #footer>           
                <el-button type="primary" :loading="addBtnLoading"  @click="confirmAdd">确 定</el-button>
                <el-button :loading="addBtnLoading"  @click="accoutAdd = false">取 消</el-button>
            </template>
        </el-drawer>

        <!-- 附件 -->
        <ab-preview :preview="preview"  @handleClose="handleClose">
            <template #button>
                <el-button @click="preview.show = false">关 闭</el-button>
            </template>
        </ab-preview>
   </div>
</template>

<script>
export default {
    name: 'account-management',
    data() {
        let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        let gangPhone = /^[0-9]{8}$/
        let telCheck = (rule, value, callback) => {
            if (!phoneReg.test(value) && !gangPhone.test(value)) {
                callback(new Error('请输入正确的手机号码'))
            } else {
                callback()
            }
        }
        let emailCheck = (rule, value, callback) => {
            if(!(/^[a-zA-Z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(value))) {
                callback(new Error("邮箱格式不正确"));
            }else{
                callback()
            }
        }
        let idCardCheck = (rule, value, callback) => {
            if(!(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value))) {
                callback(new Error("身份证号格式不正确"));
            }else{
                callback()
            }
        }
        const validatePass = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('请输入密码'))
        } else {
            let reg = new RegExp('^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$')
            if (!reg.test(value)) {
            return callback(new Error('请输入6-18位，包含大小写字母、数字的密码'))
            }
            callback()
        }
        }
        return {
            rules: {
                mobile: [
                {
                    validator: (rule, value, callback) => {
                    if (/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(value)) {
                        return callback()
                    }
                    return callback(new Error('请输入正确的手机号'))
                    },
                    trigger: 'blur',
                    required: true
                }
                ],
                email: [
                {
                    validator: (rule, value, callback) => {
                    if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
                        return callback()
                    }

                    return callback(new Error('请输入正确的邮箱地址'))
                    },
                    trigger: 'blur',
                    required: true
                }
                ]
            },   
            resetRules:{
                newPassword: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur'}
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                        if (value !== this.reseUserinfo.newPassword) {
                            callback(new Error('两次输入密码不一致!'))
                        } else {
                            callback()
                        }
                        },
                        trigger: 'blur'
                    }
                ]
            },      
            accoutAddRules:{
                realName: [
                    { required: true, message: "姓名不能为空", trigger: "blur" },
                    { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: "手机号不能为空", trigger: "blur" },
                    { validator: telCheck, trigger: "blur" }
                ],
                email: [
                    { required: true, message: "邮箱不能为空", trigger: "blur" },
                    { validator: emailCheck, trigger: "blur" }
                ],
                idCard: [
                    { required: true, message: "身份证号不能为空", trigger: "blur" },
                    { validator: idCardCheck, trigger: "blur" }
                ]
            },            
            //是否客户端权限
            isAuth:  this.$isAuth('customer:usercenter:account:add'),
            formSearch:{},//搜索参数
            isloading:false,
            btnLoading:false,
            resetBtnLoading:false,
            columns: [
                {
                    props: "realName",
                    labels: "姓名",
                    widths: 60,
                },
                {
                    props: "username",
                    labels: "登录名",
                    widths: 60,
                    slot:'slot'
                },
                {
                    props: "mobile",
                    labels: "手机号",
                    widths: 80,
                    slot:'slot'
                },
                {
                    props: "email",
                    labels: "邮箱",
                    widths: 100 ,
                    slot:'slot'
                },
                {
                    props: "roles",
                    labels: "用户角色",
                    widths: 160,
                    slot:'slot'
                },
                {
                    props: "attachUrl",
                    labels: "授权",
                    widths: 80,
                    slot:'slot'
                },

                {
                    props:"statu",
                    labels: "状态",
                    widths: 40,
                    slot:'slot'
                },
            ],
            //分页
            page: {
                currentPage: 1, //当前页
                pageSize: 10, //每页展示的数据个数
                pageSizes: [10, 20, 50, 100],
                total: 0,
            },
            tableData: [],//表格数据
            userinfo:{},//编辑用户信息
            editRow:false,//按钮动画
            formData:{},//进编辑数据

            reset:false,//重置密码
            reseUserinfo:{},
            // resetId:'',
            accoutAdd: false,
            accoutAddInfo: {},
            addBtnLoading: false,
            //账号授权
             preview: {
                show: false,
                isAgree: true,
                isFooter: true,
                isView: false,
                fileUrl: ''
            },
        }
    },
    computed:{
        /* permission(){
            return  
        } */
    },
    methods:{
        filterColumns(val){
            this.columns=val
        },
        //搜索按钮
        search(){
            this.page.currentPage = 1
            this.getListData()
        },
        //请求数据
        getListData () {
            let data = Object.assign({}, this.formSearch, { pageNum: this.page.currentPage, pageSize:this.page.pageSize })
            this.isloading = true
            this.$post('/p/user/clientList', data).then(({ data }) => {
                if (data.code === 'C0000') {
                    if(!this.isAuth){    
                        data.result.list.forEach((item)=>{
                            item.permission = false
                            if(item.id == this.$utils.getSessionStorage('userInfo').id){
                                item.permission = true
                            }
                        })
                    }else{
                        data.result.list.forEach((item)=>{
                            item.permission = true
                        })
                    }
                    this.tableData = data.result.list
                    this.page.total = data.result.total
                }
            })
            .finally(() => {
                this.isloading = false
            })
        },
        //筛选表格用户角色字段
        roleNames(array){
            let arr = array
            arr.forEach(ele=>{
                if(ele.name == '进口客户端') {
                    ele.name = '进口操作员'
                }else if(ele.name == '出口客户端') {
                    ele.name = '出口操作员'
                }else if(ele.name == '客户端管理员') {
                    ele.name = '管理员'
            }
        })
            return arr.map(item => { return item.name }).join(',')
        },
        //开关改改变时的回调
        switchState (isEnabled, id) {
            this.isloading = true
            this.$post('/p/user/enable', { id, isEnabled }).then(({ data }) => {
            if (data.code === 'C0000') {
                this.$message.success(data.message)
            }
            })
            .finally(() => {
                this.isloading = false
                this.localSearch()
            })
        },
        localSearch () {
            // this.$refs.pagination.currentChange(1)
        },
        //分页按钮
        searchForm(obj) {
            this.page.currentPage = obj.currentPage;
            this.page.pageSize = obj.pageSize;
            this.getListData()          
        },
        //编辑信息
        EditRow(val){
            this.formData={}
            this.editRow=true

            this.formData = {}
            this.$get('/p/user/get', { id: val.id }).then(({ data }) => {
                if (data.code === 'C0000') {
                    this.formData = data.result
                    this.userinfo.realName=this.formData.realName
                    this.userinfo.mobile=this.formData.loginAccount.mobile
                    this.userinfo.email=this.formData.loginAccount.email
                    this.userinfo.username=this.formData.loginAccount.username
                }
            })
        },
        //编辑确认
        confirm(){
            this.$refs.userinfo.validate((voids)=>{
                if(voids){
                    this.btnLoading=true                   
                    this.formData.mobile=this.userinfo.mobile
                    this.formData.email=this.userinfo.email
                    this.formData.loginName=this.userinfo.username
                    this.$post('/p/user/clientMod', this.formData).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message.success(data.message)
                        this.editRow = false
                        this.btnLoading = false
                        this.getListData()
                    }
                    })
                    .finally(() => {
                        this.btnLoading = false
                    })
                }
            })
        },
        //重置密码
        resetRow(row){
            this.reset=true
            this.reseUserinfo.id=row.id
        },
        resetConfirm(){
            this.$refs.resetDialog.validate((voids)=>{
                this.resetBtnLoading=true

                this.$post('/p/user/resetPassword', this.reseUserinfo).then(({ data }) => {
                if (data.code === 'C0000') {
                    this.$message.success(data.message)
                    this.userinfo = {}
                    this.reset=false
                    this.getListData()                    
                }
                })
                .finally(() => {
                this.resetBtnLoading = false
                })
            })
        },
        addHandlerEdit(){
            this.accoutAdd = true
        },
        confirmAdd(){
            this.$refs.accoutAddInfo.validate((voids)=>{
                if(voids){
                    this.addBtnLoading = true   
                    let data = this.accoutAddInfo
                    data.loginName = this.accoutAddInfo.mobile
                    this.$post('/p/user/clientAdd', data).then(({data}) =>{
                        if (data.code === 'C0000') {
                            this.accoutAddInfo= {}
                            this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                            this.accoutAdd = false
                            this.addBtnLoading = false   
                            this.getListData()
                            this.$post('/crm/client/clientAccount/addSendEsign', data.result).then( ({data}) => {
                                if (data.code === 'C0000') {
                                    // this.$router.push({
                                    //     path: '/my-signature'
                                    // })
                                    this.preview.isView = true
                                    this.preview.fileUrl = data.result
                                    this.preview.fileTitle = '账号授权书'
                                    this.preview.show = true
                                    this.pushBtnLoading = false

                                }else{
                                    this.$message({
                                        type: 'error',
                                        message: data.message,
                                        offset: 380,
                                        grouping: true,
                                    })
                                }
                            })
                        }
                    }).finally(() => {
                        this.addBtnLoading = false
                    })
                }
            })
        },
        //  查看授权书
        viewAttorney(url) {
            this.preview.fileUrl = url
            this.preview.isView = false
            this.preview.show = true
        }
    },
    created(){
        this.getListData()
    },
    activated () {
        this.search()
    }
}
</script>

<style lang="scss">
.account-management{
    .dividingLine{
        width: 0;
    }
    .ab-list-query{
        .el-menu.el-menu--horizontal{
            display: none;
        }
    }
    .addDel{
        .toolbar{
            padding: 20px 0 0 0;
        }
    }
    .drawer{
        padding: 0 20px;
        border-radius: 16px;
        .el-drawer__footer{
            text-align: center;
        }
        .el-drawer__body{
            .nameMobile{
                font-size: 22px;
                font-weight: bold;
                color: #000000;
                margin-bottom: 40px;
                margin-top: 15px;
                span{
                    font-size: 14px;
                    color: #F87243;
                    font-weight: 400;
                    margin-left: 24px;
                }
            }
        }
    }
}
</style>